export default async function $_scrollUp(e) {
    setTimeout(() => {
        e.target.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    }, 300);
}

